export const NOTIFICATION_TOAST_AUTO_DISMISS_MS = 5_000;
export const CHAT_MESSAGE_TOAST_AUTO_DISMISS_MS = 5_000;
